import { render, staticRenderFns } from "./Constitution.vue?vue&type=template&id=3a1ad322&"
import script from "./Constitution.vue?vue&type=script&lang=js&"
export * from "./Constitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports